/* tslint:disable */
/* eslint-disable */
/**
 * SupportService
 * Operation workflow management system
 *
 * The version of the OpenAPI document: v1
 * Contact: info@mrbilit.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { UploadFileDto } from '../model';
/**
 * UploadPhotoApiApiUploadPhotoUploadPost - axios parameter creator
 * 
 * @param {File} [file] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UploadPhotoApiApiUploadPhotoUploadPostAxiosParamCreator (file?: File, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/UploadPhoto/upload`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)


    if (file !== undefined) { 
        localVarFormParams.append('file', file as any);
    }


    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiUploadPhotoUploadPost operation in UploadPhotoApi.
 * @export
 * @interface UploadPhotoApiApiUploadPhotoUploadPostRequest
 */
export interface UploadPhotoApiApiUploadPhotoUploadPostRequest {
    /**
     * 
     * @type {File}
     * @memberof UploadPhotoApiApiUploadPhotoUploadPost
     */
    readonly file?: File
}

/**
* 
* @param {UploadPhotoApiApiUploadPhotoUploadPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UploadPhotoApiApiUploadPhotoUploadPost(requestParameters: UploadPhotoApiApiUploadPhotoUploadPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UploadPhotoApiApiUploadPhotoUploadPostAxiosParamCreator(requestParameters.file, options, configuration);
    const request: () => AxiosPromise<UploadFileDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
